import { Draft } from '@reduxjs/toolkit';

import { IWorkerData } from '../../initialState';

function deleteFailure(draft: Draft<IWorkerData>) {
  draft.delete.config.isLoading = false;
}

export default deleteFailure;
